export const mapInvoice = (invoice: any) => ({
  id: invoice.invoiceId ?? invoice.InvoiceId ?? "",
  rowVersion: invoice.rowVersion ?? invoice.RowVersion ?? "",
  userId: invoice.userId ?? invoice.UserId ?? "",
  adminUserId: invoice.adminUserId ?? null,
  documentUrl: invoice.documentUrl ?? invoice.DocumentUrl ?? null,
  fileName:
    invoice.fileName ??
    invoice.FileName ??
    invoice.originalFileName ??
    invoice.OriginalFileName ??
    invoice.file ??
    invoice.File ??
    "",
  documentOwner: invoice.documentOwner ?? invoice.DocumentOwner ?? "",
  type: invoice.type ?? invoice.Type ?? "",
  invoiceDate: invoice.invoiceDate ?? invoice.InvoiceDate ?? "",
  statementPeriod: invoice.statementPeriod ?? invoice.StatementPeriod ?? "",
  supplier: invoice.supplier ?? invoice.Supplier ?? "",
  extractedPoNumber: invoice.extractedPoNumber ?? "",
  documentReference: invoice.documentReference ?? invoice.DocumentReference ?? "",
  dueDate: invoice.dueDate ?? "",
  discountAmount: invoice.discountAmount ?? null,
  category: invoice.category?.trim?.() ?? "",
  productOrService: invoice.productOrService?.trim?.() ?? "",
  user: invoice.customer ?? "",
  markAsRebillable: invoice.markAsRebillable ?? "",
  description: invoice.description ?? invoice.Description ?? "",
  amount: invoice.amount ?? 0,
  currency: invoice.currency ?? invoice.Currency ?? "",
  totalAmount: invoice.totalAmount ?? invoice.TotalAmount ?? 0,
  taxAmount: invoice.taxAmount ?? 0,
  netAmount: invoice.netAmount ?? 0,
  payment: invoice.payment ?? 0,
  paid: invoice.paid ?? 0,
  paymentMethod: invoice.paymentMethod ?? "",
  submittedBy: invoice.submittedByName ?? invoice.SubmittedByName ?? invoice.submittedBy ?? invoice.SubmittedBy ?? invoice.submitterName,
  lineItems: Array.isArray(invoice.lineItems)
    ? invoice.lineItems
    : Array.isArray(invoice.LineItems)
      ? invoice.LineItems
      : [],
  stageId: invoice.stageId ?? invoice.StageId ?? 0,
  isActive: invoice.isActive ?? true,
  isDelete: invoice.isDelete ?? false,
  archiveStatus: invoice.archiveStatus ?? invoice.ArchiveStatus ?? "UnArchived",
  isFlagged: invoice.isFlagged ?? false, 
  supplierId: invoice.supplierId ?? invoice.SupplierId ?? null,
  categoryId: invoice.categoryId ?? invoice.CategoryId ?? null,
   createdDate: invoice.createdDate ?? "", 
   mergeStatus: invoice.mergeStatus ?? null,
   documentShortId: invoice.documentShortId ?? "",
   isDuplicate: invoice.isDuplicate ,
   outstandingBalance: invoice.outstandingBalance ?? invoice.OutstandingBalance ?? 0,

});

export const mapSingleInvoice = (invoice: any) => ({
  archiveStatus: invoice.ArchiveStatus ,
  invoiceId: invoice.InvoiceId ?? 0,
  rowVersion: invoice.RowVersion ?? invoice.rowVersion ?? "",
  userId: invoice.UserId ?? "",
  adminUserId: invoice.AdminUserId ?? null,
  documentUrl: invoice.DocumentUrl ?? "",
  documentOwner: invoice.DocumentOwner?.trim?.() ?? "",
  type: invoice.Type?.trim?.() ?? "",
  invoiceDate: invoice?.InvoiceDate?.split("T")[0] ?? "",
  statementPeriod:
    invoice.StatementPeriod?.split("T")[0] ??
    invoice.statementPeriod?.split("T")[0] ??
    "",
  supplier: invoice.Supplier?.trim?.() ?? "",
  extractedPoNumber: invoice.ExtractedPoNumber?.trim?.() ?? "",
  documentReference: invoice.DocumentReference?.trim?.() ?? "",
  dueDate: invoice.DueDate?.split("T")[0] ?? null,
  category: invoice.Category?.trim?.() ?? "",
  productOrService: invoice.ProductOrService?.trim?.() ?? "",
  customer: invoice.Customer ?? "",
  markAsRebillable: invoice.MarkAsRebillable?.trim?.() ?? "",
  description: invoice.Description?.trim?.() ?? "",
  amount: invoice.Amount ?? 0,
  currency: invoice.Currency?.trim?.() ?? "",
  discountAmount: invoice.DiscountAmount ?? 0,
  totalAmount: invoice.TotalAmount ?? 0,
  outstandingBalance: invoice.OutstandingBalance ?? invoice.outstandingBalance ?? 0,
  taxAmount: invoice.TaxAmount ?? 0,
  netAmount: invoice.NetAmount ?? 0,
  payment: invoice.Payment ?? 0,
  paid: invoice.Paid?.trim?.() ?? "",
  paymentMethod: invoice.PaymentMethod?.trim?.() ?? "",
  submissionMethod: invoice.SubmissionMethod ?? invoice.submissionMethod ?? "",
  submittedBy: invoice.SubmittedByName ?? invoice.submittedByName ?? invoice.SubmittedBy ?? invoice.submittedBy ?? invoice.SubmitterName,
  lineItems: Array.isArray(invoice.lineItems) ? invoice.lineItems : [],
  stageId: invoice.StageId ?? 0,
  isActive: invoice.IsActive ?? true,
  isDelete: invoice.IsDelete ?? false,
  isFlagged: invoice.isFlagged ?? false,
  supplierId: invoice.SupplierId ?? invoice.supplierId ?? null,
  categoryId: invoice.CategoryId ?? invoice.categoryId ?? null,
  isDuplicate: invoice.IsDuplicate ,
  duplicateFlagId: invoice.DuplicateFlagId ,
  mergeStatus: invoice.MergeStatus ?? null,
  mergeParentId: invoice.MergeParentId ?? null,
  reconciliationItems: (Array.isArray(invoice.Items) ? invoice.Items : Array.isArray(invoice.items) ? invoice.items : []).map(
    (item: any) => ({
      supplierStatementItemId:
        item.SupplierStatementItemId ?? item.supplierStatementItemId ?? 0,
      status: item.Status ?? item.status ?? "",
      transactionDate: item.TransactionDate ?? item.transactionDate ?? null,
      dueDate: item.DueDate ?? item.dueDate ?? null,
      source: item.Source ?? item.source ?? "",
      transactionReference:
        item.TransactionReference ?? item.transactionReference ?? "",
      type: item.Type ?? item.type ?? "",
      totalAmount: item.TotalAmount ?? item.totalAmount ?? null,
      vatAmount: item.VatAmount ?? item.vatAmount ?? null,
      netAmount: item.NetAmount ?? item.netAmount ?? null,
      dueAmount: item.DueAmount ?? item.dueAmount ?? null,
    }),
  ),
  totalItemsCount: invoice.TotalItemsCount ?? invoice.totalItemsCount ?? 0,
  missingItemsCount: invoice.MissingItemsCount ?? invoice.missingItemsCount ?? 0,
  matchedItemsCount: invoice.MatchedItemsCount ?? invoice.matchedItemsCount ?? 0,
});

export const mapToUpdateInvoicePayload = (invoiceData: any) => ({
  InvoiceId: invoiceData.invoiceId,
  UserId: invoiceData.userId,
  AdminUserId: invoiceData.adminUserId,
  DocumentUrl: invoiceData.documentUrl,
  DocumentOwner: invoiceData.documentOwner,
  Type: invoiceData.type,
  InvoiceDate: invoiceData.invoiceDate,
  Supplier: invoiceData.supplier,
  ExtractedPoNumber: invoiceData.extractedPoNumber,
  DocumentReference: invoiceData.documentReference,
  DueDate: invoiceData.dueDate,
  Category: invoiceData.category,
  ProductOrService: invoiceData.productOrService,
  Customer: invoiceData.customer,
  MarkAsRebillable: invoiceData.markAsRebillable,
  Description: invoiceData.description,
  Amount: invoiceData.amount,
  Currency: invoiceData.currency,
  DiscountAmount: invoiceData.discountAmount,
  TotalAmount: invoiceData.totalAmount,
  TaxAmount: invoiceData.taxAmount,
  NetAmount: invoiceData.netAmount,
  Payment: invoiceData.payment,
  Paid: invoiceData.paid,
  PaymentMethod: invoiceData.paymentMethod,
  LineItems: invoiceData.lineItems,
  StageId: invoiceData.stageId,
  IsActive: invoiceData.isActive,
  IsDelete: invoiceData.isDelete,
  SupplierId: invoiceData.supplierId ?? invoiceData.SupplierId ?? null,
  CategoryId: invoiceData.categoryId ?? invoiceData.CategoryId ?? null,
});